module.exports = __webpack_public_path__ + "media/flags/kh-db8edfed.svg";